import React from "react";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useMediaQuery } from '@material-ui/core';

import {
  Modal,
  Box,
  List,
  ListItem,
  Grid,
  Typography,
  TextField,
  Button
} from "@material-ui/core";

//redux
import { useDispatch, useSelector } from "react-redux";
//redux functions
import { setSelectedCounty } from "@store/counties";
import { PersonPinCircle } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  paperHolder: {
    padding: theme.spacing.unit,
    color: theme.palette.text.primary,
    whiteSpace: "wrap",
    marginBottom: theme.spacing.unit,
  },
  paperTitle: {
    fontWeight: "bold",
    whiteSpace: "wrap",
    color: theme.palette.text.primary,
    marginBottom: theme.spacing.unit,
  },
  paperText: {
    whiteSpace: "wrap",
    marginBottom: theme.spacing.unit,
  },
  transform: {
    textTransform: "capitalize",
  },
  gridItem: {
    height: "100%",
  },
  primaryLocationButton: {
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(1),
      justifyContent: "flex-start"
    },
  },
  countyTextField: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "flex-end",
    },
  },
  locationButtonText: {
    paddingLeft: theme.spacing(1),
  },
}));

const CountiesFilter = ({ openModal, setOpenModal, listComponent, ...rest }) => {
  const { countiesList } = useSelector((state) => state.counties);
  const { user } = useSelector((state) => state.user);

  const classes = useStyles();
  //redux
  const dispatch = useDispatch();

  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'), {
    defaultMatches: true,
  });

  //variables
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [originalData, setOriginalData] = React.useState([]);
  const [filteredData, setFilteredData] = React.useState([]);

  //on page load
  React.useEffect(() => {
    if (countiesList && countiesList.length > 0) {
      setOriginalData(countiesList);
      setFilteredData(countiesList);
    }
  }, [countiesList]);

  React.useEffect(() => {
    if (selectedRow !== null) {
        dispatch(setSelectedCounty(selectedRow));
        setOpenModal(false);
    }
  }, [selectedRow]);

  const handleClose = () => setOpenModal(false);
  const onFilterValueChange = (value) => {
    if (value.length > 0) {
      const matchingResults = originalData.filter((record) => {
        return record.county.toLowerCase().startsWith(value.toLowerCase());
      });
      setFilteredData(matchingResults);
    } else {
      setFilteredData(originalData);
    }
  };

  const handlePrimaryLocation = () => {
    filteredData.forEach((item) => {
      if (item.county === user.county && item.state === user.state) {
        setSelectedRow(item);
      }
    });
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isSm ? "80%" : "40%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    padding: 20,
    overflowY: "scroll",
    height: "90%",
    zIndex: 9999,
  };

  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid item container>
            <Grid item xs={12} md={6} className={classes.countyTextField}>
              <TextField
                label="Filter Counties"
                variant={"outlined"}
                fullWidth
                onChange={(e) => onFilterValueChange(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} className={classes.primaryLocationButton}>
              <Button
                onClick={handlePrimaryLocation}
                variant="outlined" 
                color="primary" 
                endIcon={              
                  <InputAdornment position="end">
                    <IconButton>
                      <PersonPinCircle color="primary" />
                    </IconButton>
                  </InputAdornment>
                } 
                size="small" 
                className={classes.transform}
              >
                <Typography variant="subtitle2" className={classes.locationButtonText}>
                  My Primary Location
                </Typography>
              </Button>
            </Grid>
          </Grid>
          <br />
          {filteredData.map((row, rowIndex) => (
            <Grid item xs={12} onClick={() => setSelectedRow(row)}>
              <Paper className={classes.paperHolder}>
                <span className={classes.paperTitle}>{row.county}</span>
                <br />
                <span className={classes.paperText}>{row.state}</span>
              </Paper>
            </Grid>
          ))}
        </Box>
      </Modal>
    </div>
  );
};

export default CountiesFilter;
